import wrapper from 'wrapper';
import Map from '../news-vj-map-module/src/js-es6/map';
import Colours from '../colours';
import NumberFormatter from '../../../app/components/country-lookup/number-formatter';

const topoURL = `${wrapper.getConfig().assetsPath}/bbc_world_map_vaccines_wgs84_russia_fix_v2_w_jersey_guernsey.json?v=${wrapper.getConfig().mapVersion}`;

const formatDoses = (num) => {
    if (num === null) return __('map-no-data');

    let numStr = Number(num).toFixed(3);
    if (num > 1) numStr = Math.round(Number(num));
    return NumberFormatter.format(wrapper.getConfig().language, numStr);
};


export default class WorldMap {
    constructor(root) {
        const { data, territories } = wrapper.getConfig().app;
        this.root = root;
        this.dataSource = data;
        this.data = {};
        this.map = null;

        data.forEach(country => {
            const { id, name, fullDosesPer100 } = country;
            this.data[id] = { id, name, fullDosesPer100 };
        });

        // Some countries are territories of another country, so
        // we check the territories list and use the parent country's
        // ISO if present
        Object.keys(territories).forEach(id => {
            const parent = territories[id];
            const { fullDosesPer100 } = this.dataForISO(parent);
            const name = __(id);
            this.data[id] = {
                id, name, fullDosesPer100, disableTooltip: true,
            };
        });
    }

    dataForISO(iso) {
        const filtered = this.dataSource.filter(country => country.id === iso);
        return filtered[0] || {};
    }

    setupEvents() {
        this.map.addTopicHandler('focus-feature', (e) => {
            this.root.parentElement.classList.add('active');

            const country = String(e.feature && e.feature.id) || '';
            wrapper.trackUserAction('map-country-selected', country.toUpperCase());
        });

        this.map.addTopicHandler('reset-map', (e) => {
            this.root.parentElement.classList.remove('active');
            wrapper.trackUserAction('map-reset');
        });

        wrapper.select('.zoom-buttons--in').addEventListener('click', (e) => {
            e.preventDefault();
            this.root.parentElement.classList.add('active');
            this.map.zoomBy(1.5);
            wrapper.trackUserAction('map-zoom-in');
        });

        wrapper.select('.zoom-buttons--out').addEventListener('click', (e) => {
            e.preventDefault();
            this.root.parentElement.classList.add('active');
            this.map.zoomBy(0.5);
            wrapper.trackUserAction('map-zoom-out');
        });
    }

    init() {
        return Promise.all([
            window.fetch(topoURL),
        ])
            .then(response => Promise.all(response.map(r => r.json())))
            .then(([topology]) => {
                const config = {
                    container: this.root,
                    projection: 'robinson',
                    topojson: topology,
                    aspectRatio: 0.38,
                    data: this.data,
                    panelTemplate: (d) => `
                        <div class="tooltip__container">
                            <div class="tooltip__name">${d.name}</div>
                            <div class="tooltip__doses">
                                <div class="tooltip__sq" style="background: ${Colours.getColour(d.fullDosesPer100)}"></div>
                                <div class="tooltip__number">${__('map-tooltip-value').replace('{{number}}', formatDoses(d.fullDosesPer100)).replace('{{percent}}', (d.fullDosesPer100 === 0 || d.fullDosesPer100 === null) ? '' : __('percent'))}</div>
                            </div>
                        </div>`,
                    overlayView: {
                        enable: false,
                    },
                    colourScales: {
                        fullDosesPer100: Colours.colourScale,
                    },
                };
                this.map = new Map(config);
                this.map.render();

                this.map.renderData('fullDosesPer100');

                this.setupEvents();
            });
    }
}
